import { SVGProps } from 'react';

const Figma = ({ props }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="43" height="64" viewBox="0 0 43 64" fill="none" {...props}>
    <path
      fill="#0ACF83"
      d="M10.622 63.733c5.864 0 10.622-4.76 10.622-10.623V42.488H10.622C4.76 42.488 0 47.247 0 53.11c0 5.864 4.759 10.623 10.622 10.623Z"
    />
    <path
      fill="#A259FF"
      d="M0 31.866c0-5.863 4.759-10.622 10.622-10.622h10.622v21.244H10.622C4.76 42.488 0 37.73 0 31.866Z"
    />
    <path fill="#F24E1E" d="M0 10.622C0 4.76 4.759 0 10.622 0h10.622v21.244H10.622C4.76 21.244 0 16.486 0 10.622Z" />
    <path
      fill="#FF7262"
      d="M21.242 0h10.622c5.864 0 10.622 4.759 10.622 10.622 0 5.864-4.758 10.622-10.622 10.622H21.242V0Z"
    />
    <path
      fill="#1ABCFE"
      d="M42.486 31.866c0 5.864-4.758 10.622-10.622 10.622-5.863 0-10.622-4.758-10.622-10.622 0-5.863 4.759-10.622 10.622-10.622 5.864 0 10.622 4.759 10.622 10.622Z"
    />
  </svg>
);

export default Figma;
